<script>
export default {
    data: () => ({
        search : '',
        isCatalogoRoute: false
    }),
    methods : {
        reloadWithSearch(){console.log(this.search)
            var params = new URLSearchParams(window.location.search);
            params.set("search_word", this.search);
            window.location.search = params.toString();
        },
        clearSearch(){
            if (!this.search) {
                var params = new URLSearchParams(window.location.search);
                params.set("search_word", '');
                window.location.search = params.toString();
            }
        },
        isCatalogRoute(){
            if (window.location.pathname == '/catalogo' || window.location.pathname == '/nuevos/catalogo') {
                this.isCatalogoRoute = true
            }
        },
        clearSearch(){
            const urlParams = new URLSearchParams(window.location.search);
            const search_url = urlParams.get('search_word');
                if (search_url) {
                    this.search = search_url;
                }
        },
        signInButtonPressed(e) {
            e.preventDefault();
            this.reloadWithSearch();
        }
    },
    computed : {
    },
    mounted() {
        this.clearSearch();
        this.isCatalogRoute();
    },
    watch : {
        search: {
            handler(newValue) {
                if (!this.search) {
                    var params = new URLSearchParams(window.location.search);
                    params.set("search_word", '');
                    window.location.search = params.toString();
                }
            },
            deep: true,
        }
    },
}
</script>
<template>
    <div class="block lg:hidden flex justify-content-around container" v-if="isCatalogoRoute">
        <form class= "container header__search header__search__filters" @submit.prevent="signInButtonPressed">
            <div class="form-inner">
                <input class="form-input form-input-helper form-input--main-search shadow-none" type="search"
                    placeholder="¿Qué auto estas buscando?" name="search" v-model="search" @blur="reloadWithSearch">
                <div @click="reloadWithSearch" class="form-helper cursor-pointer">
                    <img class="lazyload" width="16px" data-src="/assets/images/helpers/icon-search-blue.svg"
                        alt="">
                </div>
            </div>
        </form>
        <div class="mr-1 header__filters">
            <button
                    class="btn btn--green-ad btn--filters rounded-full shadow-1 z-3 lg:hidden tx-black"
                    id="trigger_filters_catalog"
                >
                    <span class="tx-24 icon-filter"
                        ><i class="fas fa-filter"></i
                    ></span>
                    <span class="tx-24 icon-times hidden"
                        ><i class="fas fa-times"></i
                    ></span>
                    <!-- <img class="icon-times hidden" width="18px" src="/assets/images/helpers/icon-times.svg"> -->
                </button>
        </div>
    </div>
</template>

<style>

</style>
